module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<thead>\n  <th>Bill</th>\n  <th class="text-center">Description</th>\n  <th class="text-end">Date</th>\n</thead>\n<tbody ></tbody>';
}
return __p;
};
